import React from "react";
import about_img from "../../assets/banner/about_img.jpg";

const AboutBanner = ({ text, des }) => {
  return (
    <div>
      <section className="about-header">
        <div className="about-banner">
          <img src={about_img} alt="About Iconic Unity Group" />
          <div className="about-banner-content">
            <h1 className="about-us-h1">{text}</h1>
            <p>{des}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutBanner;
